/*
*###############################################################################
*Module Name                   : ScaleDataPrintContent.js                      #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath Arandara                        #
*Date                          : Friday, February 02nd 2024, 9:18:43 Am        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import DPDropDown from "framework/components/DPDropDown"
import DPTextBox from "framework/components/DPTextBox"
import React, { useEffect, useState } from "react"

import {
  Col,
  Row,
  Button,
  Table,
  Alert
} from "reactstrap"

const ScaleDataContent = ({

  disabled,
  extCode,
  mainExtCode,
  setMainExtCode,
  show,
  AlertMsg,
  AlertColor,
  ErrorMsg,
  setMainExtCodeOnClick,
  logLocation,
  SetLoadingAlert,
  SetLoadingAlerttitle

}) => {

  const handleDownload = async () => {
    if (mainExtCode == "") return


    const fileName = "output." + mainExtCode.toLowerCase()
    try {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Downloading...")
      const authToken = localStorage.getItem("authToken")
      const ApiURL = window.Links.ApiURL
      const response = await fetch(`${ApiURL}common/saveAndDownloadScaller/${mainExtCode}/${logLocation}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
      });

      // Check if the request was successful (status code in the range of 200-299)
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setMainExtCode("");
      } else {
        // Handle unsuccessful response (status code outside the range of 200-299)
        const errorData = await response.json(); // Assuming the server returns JSON
        console.error('Error:', errorData);
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error('Fetch error:', error);
    }finally{
      SetLoadingAlert(false)
    }
  };

  return (
    <React.Fragment>
      <Row>
        {show ? (
          <Alert color={AlertColor} role="alert">
            {AlertMsg}
            <br />
            <small>{ErrorMsg}</small>
          </Alert>
        ) : null}
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            labelText={"File Extension *"}
            optionGroup={extCode}
            selectedGroup={mainExtCode}
            onChange={setMainExtCodeOnClick}
            disabled={disabled}
          />
        </Col>
        <Col sm={12} md={6} className="mb-12-sm">
          <Button color="primary"
            className="btn-sm"
            // disabled={productCode != "" ? false : true}
            onClick={() => handleDownload()}
          >
            Download
          </Button>
        </Col>
      </Row >
      <Row>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </Row>
    </React.Fragment >
  )
}
export default ScaleDataContent